import type { IProfileState } from '@/store/modules/profile/types';

export const state: IProfileState = {
  profile: null,
  profile_meta: null,
};
